import { CMSBlockTitle } from '../cms-block-title';
import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './text-image-block-view.css';

import type { TextImageBlockViewModel } from '../../view-models/blocks/text-image-block.viewModel';

export function TextImageBlockView({ title, body, image, layout }: TextImageBlockViewModel) {
  function renderImage() {
    return (
      <div className={css.flexChild}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className={css.image} src={image.src ?? '#'} alt={image.alt} title={image.title} />
      </div>
    );
  }
  function renderBody() {
    return (
      <div className={css.flexChild}>
        <div className={css.htmlContent} dangerouslySetInnerHTML={{ __html: body.processed }} />
      </div>
    );
  }
  return (
    <CMSBlockWrapper>
      {title && <CMSBlockTitle titleTag="h2" value={title} />}

      <div className={css.flexContainer}>
        {layout === 'left' && renderImage()}
        {renderBody()}
        {layout === 'right' && renderImage()}
      </div>
    </CMSBlockWrapper>
  );
}
